/**
* Category Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Category Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'category-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      let oldIndex = 0;
      $( '.category-slider' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--category-slider' )[0], {
          pagination: false,
          arrows: true,
          gap: '20px',
          perPage: 3,
          perMove: 1,
          speed: 1000,
          breakpoints: {
            1024: {
              perPage: 2,
            },
            768: {
              perPage: 1,
            },
          },
        } );

        splide.mount();

        splide.on( 'move', function( newIndex, prevIndex, destIndex ) {
          if ( destIndex > oldIndex && destIndex !== -1 ) {
            $( '.category-slider .splide__slide' ).addClass( 'is-dragging-left' );
          } else {
            $( '.category-slider .splide__slide' ).addClass( 'is-dragging-right' );
          }

          setTimeout( function() {
            $( '.category-slider .splide__slide' ).removeClass( 'is-dragging-left is-dragging-right' );
          }, 1000 );

          if ( destIndex == -1 ) {
            oldIndex = splide.length - 1;
          } else {
            oldIndex = newIndex;
          }
        } );

        splide.on( 'overflow', function( isOverflow ) {
          splide.options = {
            arrows: isOverflow,
            drag: isOverflow,
          };
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'category-slider', COMPONENT );
} )( app );
